/* ALPNORD – Theme-Logik (Dawn-Basis, an-System)
   Ersetzt die Demo-Logik der HTML-Previews durch die Shopify Cart AJAX API. */
(function () {
  'use strict';

  var routes = window.anRoutes || { cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart_url: '/cart' };
  var settings = window.anSettings || { freeShipping: 49, moneyFormat: '{{amount_with_comma_separator}} €' };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Geld formatieren ---------- */
  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var format = settings.moneyFormat || '{{amount_with_comma_separator}} €';
    var parts = value.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDots)
      .replace(/\{\{\s*amount\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function toast(msg) {
    var t = $('#an-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._to);
    t._to = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- Countdown (rollierend) ---------- */
  function countdown() {
    var els = $$('[data-an-countdown]');
    if (!els.length) return;
    els.forEach(function (el) {
      var hours = parseInt(el.dataset.anCountdown, 10) || 4;
      var span = hours * 3600000;
      var left = span - (Date.now() % span);
      var h = String(Math.floor(left / 3600000)).padStart(2, '0');
      var m = String(Math.floor((left % 3600000) / 60000)).padStart(2, '0');
      var s = String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
      el.textContent = h + ':' + m + ':' + s;
    });
  }

  /* ---------- Drawer & Mobile-Nav ---------- */
  var drawer, overlay, mnav;
  function setCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('on', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (overlay) overlay.classList.toggle('on', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function setNav(open) {
    if (!mnav) return;
    mnav.classList.toggle('on', open);
    if (overlay) overlay.classList.toggle('on', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  /* ---------- Warenkorb ---------- */
  function renderCart(cart) {
    var counter = $('#an-cartc');
    if (counter) {
      counter.textContent = cart.item_count;
      counter.style.display = cart.item_count ? 'grid' : 'none';
    }

    var lines = $('#an-lines');
    if (lines) {
      if (!cart.items.length) {
        lines.innerHTML = '<div class="an-empty">' + (lines.dataset.empty || 'Dein Rucksack ist noch leer.') + '</div>';
      } else {
        lines.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? '<img class="an-prodimg" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '';
          return '<div class="an-li">'
            + '<div class="an-li-img">' + img + '</div>'
            + '<div class="an-li-info"><div class="nm">' + it.product_title + '</div>'
            + (it.variant_title && it.variant_title.indexOf('Default') === -1 ? '<div class="an-li-var">' + it.variant_title + '</div>' : '')
            + '<div class="pr">' + money(it.final_line_price) + '</div>'
            + '<div class="an-qty">'
            + '<button type="button" data-an-qty="' + (i + 1) + '" data-to="' + (it.quantity - 1) + '" aria-label="Menge verringern">&minus;</button>'
            + '<span>' + it.quantity + '</span>'
            + '<button type="button" data-an-qty="' + (i + 1) + '" data-to="' + (it.quantity + 1) + '" aria-label="Menge erhöhen">+</button>'
            + '</div></div>'
            + '<button class="an-li-rm" type="button" data-an-qty="' + (i + 1) + '" data-to="0">Entfernen</button>'
            + '</div>';
        }).join('');
      }
    }

    var total = $('#an-total');
    if (total) total.textContent = money(cart.total_price);

    var ship = $('#an-shipbar');
    var threshold = (settings.freeShipping || 0) * 100;
    if (ship && threshold > 0) {
      var missing = threshold - cart.total_price;
      ship.innerHTML = missing > 0
        ? 'Noch <b>' + money(missing) + '</b> bis zum kostenlosen Versand'
        : '✓ Kostenloser Versand freigeschaltet';
    }
  }

  function fetchCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(id, qty) {
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || 'Konnte nicht hinzugefügt werden.'); return null; }
        return fetchCart().then(function (cart) { setCart(true); return cart; });
      })
      .catch(function () { toast('Netzwerkfehler – bitte noch einmal versuchen.'); });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return cart;
      });
  }

  /* ---------- Startseite: Filter-Pills ---------- */
  function pills() {
    var cards = $$('#an-grid .an-card');
    // Pills, die als Link auf eine Kategorie zeigen, bleiben unangetastet.
    var buttons = $$('button.an-pill');
    if (!buttons.length) return;

    // Ohne Produkte im Raster gibt es nichts zu filtern – Tag-Pills dann ausblenden,
    // damit keine toten Schalter stehen bleiben.
    if (!cards.length) {
      buttons.forEach(function (b) { b.remove(); });
      return;
    }

    buttons.forEach(function (b) {
      var f = b.dataset.f;
      if (f && f !== 'all' && !cards.some(function (c) { return c.dataset.cat === f; })) b.remove();
    });

    $$('.an-pill').forEach(function (b) {
      if (b.tagName === 'A') return;
      b.addEventListener('click', function () {
        $$('.an-pill').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        cards.forEach(function (c) {
          c.style.display = (b.dataset.f === 'all' || c.dataset.cat === b.dataset.f) ? 'flex' : 'none';
        });
      });
    });
  }

  /* ---------- Kategorieseite: Preis-/Verfügbarkeitsfilter + Sortierung ---------- */
  function collectionFilters() {
    var grid = $('#an-katgrid');
    if (!grid) return;
    var cards = $$('.an-card', grid);
    var visible = $('#an-visible');

    function apply() {
      var ranges = $$('.an-fp:checked').map(function (i) {
        return [parseFloat(i.dataset.min), parseFloat(i.dataset.max)];
      });
      var onlySale = $('#an-fsale') && $('#an-fsale').checked;
      var onlyLow = $('#an-flow') && $('#an-flow').checked;
      var shown = 0;

      cards.forEach(function (c) {
        var price = parseFloat(c.dataset.price || '0');
        var inRange = !ranges.length || ranges.some(function (r) { return price >= r[0] && price < r[1]; });
        var ok = inRange
          && (!onlySale || c.dataset.sale === 'true')
          && (!onlyLow || c.dataset.low === 'true');
        c.style.display = ok ? 'flex' : 'none';
        if (ok) shown++;
      });
      if (visible) visible.textContent = shown;
    }

    $$('.an-fp, #an-fsale, #an-flow').forEach(function (i) { i.addEventListener('change', apply); });

    var sort = $('[data-an-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* ---------- Produktseite ---------- */
  function product() {
    var main = $('#an-gmain');
    if (main) {
      $$('.an-gt').forEach(function (t) {
        t.addEventListener('click', function () {
          $$('.an-gt').forEach(function (x) { x.classList.remove('on'); });
          t.classList.add('on');
          var img = main.querySelector('img');
          if (img && t.dataset.full) { img.src = t.dataset.full; img.srcset = ''; img.alt = t.dataset.alt || ''; }
        });
      });
    }

    var qtyEl = $('#an-pqty');
    $$('[data-an-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyEl) return;
        var next = Math.max(1, parseInt(qtyEl.textContent, 10) + parseInt(b.dataset.anStep, 10));
        qtyEl.textContent = next;
      });
    });

    // Variantenauswahl: Buttons steuern das versteckte <select>
    var select = $('#an-variant-select');
    if (select) {
      $$('.an-vopt').forEach(function (b) {
        b.addEventListener('click', function () {
          var group = b.closest('.an-vopts');
          $$('.an-vopt', group).forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');

          var chosen = $$('.an-vgrp').map(function (g) {
            var on = g.querySelector('.an-vopt.on');
            return on ? on.dataset.value : null;
          }).filter(Boolean);

          var match = Array.prototype.find.call(select.options, function (o) {
            return chosen.every(function (v) { return o.textContent.indexOf(v) !== -1; });
          });
          if (!match) return;

          select.value = match.value;
          var buy = $('#an-buybtn');
          if (buy) buy.dataset.anAdd = match.value;
          var price = $('#an-buyprice');
          if (price && match.dataset.price) price.textContent = match.dataset.price;
        });
      });
    }

    var sticky = $('#an-sticky'), buybox = $('#an-buybtn');
    if (sticky && buybox) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('on', buybox.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }
  }

  /* ---------- Empfehlungen ---------- */
  function recommendations() {
    var box = $('[data-an-recommendations]');
    if (!box || !box.dataset.url) return;
    fetch(box.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-an-recommendations]');
        if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
        else { var sec = box.closest('.an-sec'); if (sec) sec.remove(); }
      })
      .catch(function () {});
  }

  /* ---------- Start ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    drawer = $('#an-drawer');
    overlay = $('#an-ov');
    mnav = $('#an-mnav');

    countdown(); setInterval(countdown, 1000);
    pills(); collectionFilters(); product(); recommendations();
    if (drawer) fetchCart();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('#an-cart-btn')) { e.preventDefault(); setCart(true); return; }
      if (t.closest('#an-drawer-close')) { setCart(false); return; }
      if (t.closest('#an-burger')) { setNav(true); return; }
      if (t.id === 'an-ov') { setCart(false); setNav(false); return; }
      if (t.closest('.an-mnav a')) { setNav(false); return; }

      var add = t.closest('[data-an-add]');
      if (add && !add.disabled) {
        e.preventDefault();
        var qty = $('#an-pqty');
        addToCart(add.dataset.anAdd, qty ? parseInt(qty.textContent, 10) : 1);
        return;
      }

      var qtyBtn = t.closest('[data-an-qty]');
      if (qtyBtn) { e.preventDefault(); changeLine(qtyBtn.dataset.anQty, qtyBtn.dataset.to); return; }

      var faq = t.closest('[data-an-faq]');
      if (faq) {
        e.preventDefault();
        var q = faq.parentElement;
        var body = q.querySelector('.an-q-b');
        var open = q.classList.contains('open');
        q.classList.toggle('open', !open);
        if (body) body.style.maxHeight = open ? null : body.scrollHeight + 'px';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setCart(false); setNav(false); }
    });
  });
})();
